import mobx, { observable, action, computed } from 'mobx';
import api from '../../api';
import accountStore from '../accountStore';
import appStore from '../appStore';

export default class TotoStore {

	@observable isLoading = 0;
	@observable dict = {};
	@observable data = '';
	@observable currencyId = 0;
	@observable success = '';
	@observable dataBet = '';
	@observable showWarning = false;
	@observable amount = {
		current: 0,
		min: 0,
		per_option: ''
	};
	count = 0;

	@observable list = new Map();
	store = null;
	account = null;
	app = null;

	constructor(store, account, app) {
		this.store = store;
		this.account = account;
		this.app = app;
	}

	@action init() {
		this.store.isLoading = 0;
		this.reset();
		this.getData();
	}

	@action reset() {
		this.data = '';
		this.success = '';
		this.clearAll();
		this.store.clearResult();
	}

	@action selectCurrency(v) {
		this.currencyId = v;
		this.showWarning = this.app.currency_id != this.currencyId;
		this.calc();
	}

	@computed get currency() {
		return this.data.currency[this.currencyId];
	}

	@action clearOdds(manual=0) {
		this.list.keys().forEach(k => {
			if(this.list.get(k).manual <= manual) {
				this.list.get(k).manual = 0;
				this.list.get(k).o.fill(0);
			}
		})
	}

	@action clearAll() {
		this.clearOdds(1);
		this.amount.current = '';
		this.amount.per_option = '',
		this.amount.min = 0;
		this.count = 0;
	}

	@action hideSuccess() {
		this.success = '';
	}

	@action checkOdd(id, el, indx, manual=0) {
		if (manual >= this.list.get(id).manual) {
			this.list.get(id).manual = el ? manual : 0;
			this.list.get(id).o[indx] = el;
		}
		this.calc();
	}

	@action random(manual=0) {
		this.clearOdds(manual);
		this.list.keys().forEach(i => {
			this.checkOdd(i, 1, Math.floor(Math.random() * 3), manual);
		})
	}

	@action generateCheck() {
		Object.keys(this.data.games).forEach((id) => {
			let i = {};
			i['manual'] = 0;
	    i['o'] = [];
			for(let j = 1; j < 4; j++) {
	    	i.o.push(0);
	    }
	    this.list.set(id, i);
		});
	}

	@action getData(){
		api.toto.getData().then(
			action( data => {
				if (data.code == "OK") {
					this.data = data.result;
					this.currencyId = String(data.result.currency_id);
					this.generateCheck();
					this.amount.min = this.currency.min;
				}
			}))
      .catch(action(err => {
        this.store.setResult('SERVER_TEMPORARILY_DOWN');
      }))
      .finally(action(() => { this.store.isLoading = 1 }));
	}

	@action calc() {
      let cnt;
      let count = 1;
      this.list.keys().forEach(i => {
      	cnt = 0;
      	this.list.get(i).o.forEach(v => {
      		cnt += v;
      	})
      	count *= cnt;
      })

      this.count = count;

      if (count > 0) {
          this.calcHTML();
      } else {
      	this.amount.min = this.currency.min;
      }
  }

  @action inputAmount(val) {
  	const number = val.replace(/[^.\d]+/g,"").replace( /^([^\.]*\.)|\./g, '$1');
    if (number.toString().length > 0){
      this.amount.current = number;
    } else {
     	this.amount.current = '';
    }
    this.calc();
  }

  @action copy() {
  	this.amount.current = this.amount.min;
  	this.calc();
  }

  @action calcHTML() {
    this.amount.min        = this.currency.min * this.count;
    this.amount.per_option = Math.round(this.amount.current / this.count * 100) / 100;
  }

  isValidBet = () => {
		let isValid = true;
		if (this.account.access == 0) {
			this.store.setResult('AUTH_ERROR');
			isValid = false;
		} else if (this.count == 0) {
			this.store.setResult('TOTO_ERROR_COUNT');
			isValid = false;
		} else if (this.currencyId != this.app.currency_id) {
			this.store.setResult('TOTO_ERROR_CURRENCY');
			isValid = false;
		} else if (this.amount.current == 0 || this.amount.current.length === 0) {
			this.store.setResult('EMPTY_AMOUNT');
			document.getElementById('toto-amount').focus();
			isValid = false;
		} else if (this.amount.current < this.amount.min) {
			this.store.setResult('LOW_AMOUNT');
			isValid = false;
		}
		return isValid;
	};

	@action dobet() {
		this.store.clearResult();
    if (!this.isValidBet()) {
    	return Promise.resolve();
    }

		const bet = {};
		const data = {
			action: 'dobet',
			count: this.count,
			amount: this.amount.current,
			cid: this.currencyId,
			id: this.data.id
		};
		const outcome = ['1', 'X', '2'];

		Object.keys(this.data.games).forEach((i) => {
			bet[this.data.games[i].line_id] = {};
			for(let j = 0; j < 3; j++) {
				 bet[this.data.games[i].line_id][outcome[j]] = this.list.get(i).o[j];
			}
		});
		data['bet'] = bet;

		return api.toto.doBet(data).then(
			action( data => {
				if (data.code == "OK") {
					this.success = data.result;
				} else {
					this.store.setResult(data.text ? data.text : 'SERVER_TEMPORARILY_DOWN');
				}
			}))
			.catch(action(err => {
				this.store.setResult('SERVER_TEMPORARILY_DOWN');
			}));
  }
}



// WEBPACK FOOTER //
// ./src/stores/totoStore/toto.js